import { SetMemberArchivedDocument } from "@pathwright/graphql-client/src/generated"

export default SetMemberArchivedDocument
